import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, withCtx as _withCtx, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-31aa5ef2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-lg text-center text-textPrimary" }, "Editar Escala", -1))
const _hoisted_2 = { class: "flex flex-1 min-h-0" }
const _hoisted_3 = { class: "w-[320px] shrink-0 bg-[#F0F0F4] border-r border-[#D8D8E2] flex flex-col" }
const _hoisted_4 = {
  key: 0,
  class: "px-4 pt-4 pb-2 text-left text-base font-normal leading-6 tracking-[0.08px] text-[#68688D]"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "text-base leading-6 whitespace-nowrap" }
const _hoisted_7 = { class: "flex-1 flex flex-col min-w-0" }
const _hoisted_8 = { class: "flex-1 overflow-y-auto p-6" }
const _hoisted_9 = { class: "font-bold text-xl leading-6 text-[#323232] mb-6 text-left" }
const _hoisted_10 = { class: "shrink-0 px-6 pb-6" }
const _hoisted_11 = { class: "flex gap-6 w-full" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "unsaved-card" }
const _hoisted_14 = { class: "unsaved-header" }
const _hoisted_15 = { class: "unsaved-title" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1 1L13 13M1 13L13 1",
    stroke: "#323232",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { class: "unsaved-content" }
const _hoisted_19 = { class: "unsaved-message" }

import { ref, computed, watch } from 'vue'
import { storeToRefs } from 'pinia'
import {
  mdiSwapHorizontal,
  mdiLockOpenVariant,
  mdiLocationEnter,
  mdiEmailOpenMultipleOutline,
  mdiFileDocumentOutline,
  mdiFileDocumentCheckOutline
} from '@mdi/js'
import {
  hospitalBuildingIcon,
  scheduleRequirementsIcon,
  paymentPolicyIcon
} from '@/assets/icons/scheduleTabIcons'

import { EModals, useModalStore } from '@/pinia-store/useModalStore'
import ModalVue from '@/components/designSystem/modals/Modal.vue'
import OutlinedButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'

import ScheduleBasicInfo from './tabs/ScheduleBasicInfoTab.vue'
import ScheduleRequirementsTab from './tabs/ScheduleRequirementsTab.vue'
import PolicyLinksTab from './tabs/PolicyLinksTab.vue'
import PolicyPaymentTab from './tabs/PolicyPaymentTab/index.vue'
import ScheduleDsAttendancePolicyTab from './tabs/ScheduleDsAttendancePolicyTab.vue'
import ScheduleApprovalFlowTab from './tabs/ScheduleApprovalFlowTab.vue'
import ExchangeConfigTab from './tabs/ExchangeConfigTab.vue'
import QualificationTab from './tabs/QualificationTab.vue'
import QualificationDocTab from './tabs/QualificationDocTab.vue'

import { ScheduleResponse } from '@/Network/Types/Responses/ScheduleUnitResponses'
import PaymentPolicyService from '@/Network/Services/DsPaymentPolicyService'
import {
  PaymentPolicy,
  PaymentPolicyByIdResponse
} from '@/Network/Types/Responses/DsPaymentPolicyResponses'
import PolicyPaymentModal from './tabs/PolicyPaymentTab/PolicyPaymentModal.vue'
import { useCreateScheduleStore } from '@/pinia-store/useCreateScheduleStore'
import { useFeatureFlags } from '@/hooks/useFeatureFlags'
import { useErrorToast } from '@/composables/useErrorToast'
import { usePermissionsStore } from '@/pinia-store/usePermissionsStore'
import { AuthorizationPermissions, AuthorizationResourcesAndSubjects } from '@/types/authorization'

const TAB_BASIC_INFO = 'Informações básicas'
const TAB_REQUIREMENTS = 'Requisitos da escala'
const TAB_EXCHANGE_CONFIG = 'Trocas e jornada'
const TAB_EXCEPTIONALITY = 'Excepcionalidade'
const TAB_ATTENDANCE_POLICY = 'Política de registro de plantão'
const TAB_PAYMENT_POLICY = 'Política de pagamento'
const TAB_RESTRICTION_POLICY = 'Política de restrição'
const TAB_QUALIFICATION = 'Qualificação para repasse'
const TAB_QUALIFICATION_DOC = 'Qualificação documental'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    scheduleDetails: {},
    initialTabSlug: {}
  },
  setup(__props: any) {

const props = __props;

const { flags } = useFeatureFlags()
const { notifyError } = useErrorToast()
const permissionsStore = usePermissionsStore()

const canViewExceptionality = computed(() => {
  return permissionsStore.checkAnyRessources({
    permission: AuthorizationPermissions.StationExceptionalitiesExceptionViewing,
    resourceType: AuthorizationResourcesAndSubjects.StationExceptionalitiesSchedule
  })
})
const TAB_SLUGS: Record<string, string> = {
  // "Abrir configuração da escala" do segmento "Ocupado sem identificação" desativado.
  'informacoes-basicas': TAB_BASIC_INFO,
  'qualificacao-repasse': TAB_QUALIFICATION,
  'qualificacao-documental': TAB_QUALIFICATION_DOC,
  // M7 (balão ⑯) — "ver política" do Detalhes do Plantão e da aba Requisitos cai
  // direto na aba da política, que é onde a exigência de check mora agora.
  'registro-de-plantao': TAB_ATTENDANCE_POLICY
}



const modalName = EModals.EDIT_SCHEDULE
const { modals } = storeToRefs(useModalStore())
const modalStore = useModalStore()
const forceCloseModal = () => {
  showUnsavedAlert.value = false
  pendingAction.value = null
  modalStore.toggleModal(modalName)
  tab.value = 1
}

function getCurrentTabDirty(): boolean {
  const tabName = currentTabName.value
  const dirtyByRef: Record<string, { value?: { hasUnsavedChanges?: boolean } }> = {
    [TAB_BASIC_INFO]: basicInfoTabRef,
    [TAB_REQUIREMENTS]: requirementsTabRef,
    [TAB_EXCHANGE_CONFIG]: exchangeConfigTabRef,
    [TAB_EXCEPTIONALITY]: approvalFlowTabRef
  }
  if (tabName in dirtyByRef) return dirtyByRef[tabName].value?.hasUnsavedChanges ?? false
  if (tabName === TAB_ATTENDANCE_POLICY || tabName === TAB_RESTRICTION_POLICY)
    return hasUnsavedChanges.value
  return false
}

function guardedAction(action: () => void) {
  if (getCurrentTabDirty()) {
    pendingAction.value = action
    showUnsavedAlert.value = true
  } else {
    action()
  }
}

const handleToggleModal = () => {
  guardedAction(forceCloseModal)
}

/**
 * M7 (Tela 4) — o bloco somente-leitura da aba Requisitos não reintroduz os
 * interruptores: ele manda para a aba onde a política os edita. Passa pelo mesmo
 * guardião de alterações não salvas que a troca de aba pelo menu.
 */
function goToAttendancePolicyTab() {
  const index = tabs.value.indexOf(TAB_ATTENDANCE_POLICY)
  if (index === -1) return
  guardedAction(() => {
    tab.value = index + 1
  })
}

const isSaving = ref(false)
const hasUnsavedChanges = ref(false)
const showUnsavedAlert = ref(false)
const pendingAction = ref<(() => void) | null>(null)

const requirementsTabRef = ref()
const basicInfoTabRef = ref()
const policyLinksTabRef = ref()
const policyPaymentTabRef = ref()
const approvalFlowTabRef = ref()
const exchangeConfigTabRef = ref()
const schaleRegistroTabRef = ref()
const editedRequirements = ref(null)

const tab = ref(1)

const tabs = computed(() => {
  return [
    TAB_BASIC_INFO,
    TAB_REQUIREMENTS,
    TAB_EXCHANGE_CONFIG,
    ...(flags.enabledApprovalFlow && canViewExceptionality.value ? [TAB_EXCEPTIONALITY] : []),
    TAB_RESTRICTION_POLICY,
    TAB_ATTENDANCE_POLICY,
    TAB_PAYMENT_POLICY,
    ...(flags.enabledPolicyModules ? [TAB_QUALIFICATION, TAB_QUALIFICATION_DOC] : [])
  ]
})

const tabIcons: Record<string, string> = {
  [TAB_BASIC_INFO]: hospitalBuildingIcon,
  [TAB_REQUIREMENTS]: scheduleRequirementsIcon,
  [TAB_EXCHANGE_CONFIG]: mdiSwapHorizontal,
  [TAB_EXCEPTIONALITY]: mdiLockOpenVariant,
  [TAB_ATTENDANCE_POLICY]: mdiLocationEnter,
  [TAB_PAYMENT_POLICY]: paymentPolicyIcon,
  [TAB_RESTRICTION_POLICY]: mdiFileDocumentOutline,
  [TAB_QUALIFICATION]: mdiEmailOpenMultipleOutline,
  [TAB_QUALIFICATION_DOC]: mdiFileDocumentCheckOutline
}

const currentTabName = computed(() => tabs.value[tab.value - 1])

const saveLabels: Record<string, string> = {
  [TAB_BASIC_INFO]: 'Salvar informações básicas',
  [TAB_REQUIREMENTS]: 'Salvar requisitos da escala',
  [TAB_EXCHANGE_CONFIG]: 'Salvar trocas e jornada',
  [TAB_EXCEPTIONALITY]: 'Salvar excepcionalidade',
  [TAB_RESTRICTION_POLICY]: 'Salvar política de restrição'
}

const currentSaveLabel = computed(() => saveLabels[currentTabName.value] || '')
const hasSaveAction = computed(() => !!currentSaveLabel.value)

const saveDisabled = computed(() => {
  if (currentTabName.value === TAB_BASIC_INFO) return isSaving.value || !editedSchedule.value
  if (currentTabName.value === TAB_EXCHANGE_CONFIG)
    return isSaving.value || exchangeConfigTabRef.value?.isFormValid === false
  if (currentTabName.value === TAB_RESTRICTION_POLICY)
    return !hasUnsavedChanges.value || isSaving.value
  return isSaving.value
})

const editedSchedule = ref<ScheduleResponse | null>(null)

const service = new PaymentPolicyService()

const isCreatingPolicy = ref(false)
const isEditingPolicy = ref(false)
const editedPaymentPolicy = ref<PaymentPolicyByIdResponse | null>(null)
const requiresDoctorPaymentFormationRef = ref(false)
const scheduleStore = useCreateScheduleStore()

const closePolicyModal = () => {
  isCreatingPolicy.value = false
  isEditingPolicy.value = false
  editedPaymentPolicy.value = null

  modalStore.toggleModal(EModals.EDIT_SCHEDULE)
}

const handleCreatePolicy = () => {
  modalStore.toggleModal(EModals.EDIT_SCHEDULE)
  scheduleStore.resetStep4()
  isCreatingPolicy.value = true
}

const handlePolicyChange = () => {
  closePolicyModal()
  policyPaymentTabRef.value?.fetchPolicies()
}

const handleEditPolicy = async (policy: PaymentPolicy) => {
  try {
    const response = await service.getById(policy.id)
    editedPaymentPolicy.value = response

    modalStore.toggleModal(EModals.EDIT_SCHEDULE)

    isEditingPolicy.value = true
  } catch (error) {
    console.error('Erro ao carregar política para edição:', error)
    notifyError(error, 'Não foi possível abrir a política de pagamento para edição.')
  }
}

const handleRequirementsLoaded = (requiresFormation: boolean) => {
  requiresDoctorPaymentFormationRef.value = requiresFormation
}

const handleUpdate = async (newSchedule: ScheduleResponse) => {
  editedSchedule.value = newSchedule
}

function handleUpdateRequirements(data: any) {
  editedRequirements.value = data
}

const changeTab = (index: number) => {
  if (index === tab.value) return
  guardedAction(() => {
    tab.value = index
  })
}

const confirmLeave = () => {
  showUnsavedAlert.value = false
  pendingAction.value?.()
  pendingAction.value = null
}

const cancelLeave = () => {
  showUnsavedAlert.value = false
  pendingAction.value = null
}

watch(
  () => modals.value[modalName],
  (isOpen) => {
    if (!isOpen || !props.initialTabSlug) return
    const label = TAB_SLUGS[props.initialTabSlug]
    if (!label) return
    const index = tabs.value.indexOf(label)
    if (index !== -1) {
      tab.value = index + 1
    }
  }
)

const handleSave = async () => {
  const currentTab = currentTabName.value

  if (currentTab === TAB_BASIC_INFO) {
    await basicInfoTabRef.value?.handleSave()
  } else if (currentTab === TAB_REQUIREMENTS) {
    await requirementsTabRef.value?.handleSave()
  } else if (currentTab === TAB_EXCHANGE_CONFIG) {
    await exchangeConfigTabRef.value?.handleSave()
    forceCloseModal()
  } else if (currentTab === TAB_ATTENDANCE_POLICY) {
    await ScheduleDsAttendancePolicyTab.value?.handleSave()
  } else if (currentTab === TAB_EXCEPTIONALITY) {
    await approvalFlowTabRef.value?.handleSave()
  } else if (currentTab === TAB_RESTRICTION_POLICY) {
    await policyLinksTabRef.value?.handleSave()
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ModalVue, {
      onClose: handleToggleModal,
      modalActive: _unref(modals)[_unref(modalName)],
      "max-width": "!w-[80vw] !max-w-[80vw]",
      "min-height": "90vh",
      "max-height": "90vh",
      class: "figma-custom-modal",
      "has-header-border": true
    }, {
      header: _withCtx(() => [
        _hoisted_1
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("nav", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, (label, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: label }, [
                (label === TAB_RESTRICTION_POLICY)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, " Políticas "))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  onClick: ($event: any) => (changeTab(index + 1)),
                  class: _normalizeClass(["flex items-center gap-4 px-4 py-4 text-left transition-colors duration-200", 
              tab.value === index + 1
                ? 'bg-[#2F7F91] text-white font-bold'
                : 'text-[#16161D] hover:bg-[#E8E8EE]'
            ])
                }, [
                  _createVNode(_component_v_icon, {
                    size: "24",
                    icon: tabIcons[label],
                    color: tab.value === index + 1 ? 'white' : '#16161D'
                  }, null, 8, ["icon", "color"]),
                  _createElementVNode("span", _hoisted_6, _toDisplayString(label), 1)
                ], 10, _hoisted_5)
              ], 64))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("h2", _hoisted_9, _toDisplayString(currentTabName.value), 1),
              (tabs.value[tab.value - 1] === TAB_BASIC_INFO)
                ? (_openBlock(), _createBlock(ScheduleBasicInfo, {
                    key: 0,
                    ref_key: "basicInfoTabRef",
                    ref: basicInfoTabRef,
                    "schedule-id": props.scheduleDetails.id,
                    isSaving: isSaving.value,
                    "onUpdate:isSaving": _cache[0] || (_cache[0] = ($event: any) => ((isSaving).value = $event)),
                    "onUpdate:modelValue": handleUpdate
                  }, null, 8, ["schedule-id", "isSaving"]))
                : _createCommentVNode("", true),
              (tabs.value[tab.value - 1] === TAB_REQUIREMENTS)
                ? (_openBlock(), _createBlock(ScheduleRequirementsTab, {
                    key: 1,
                    ref_key: "requirementsTabRef",
                    ref: requirementsTabRef,
                    "schedule-id": props.scheduleDetails.id,
                    isSaving: isSaving.value,
                    "onUpdate:isSaving": _cache[1] || (_cache[1] = ($event: any) => ((isSaving).value = $event)),
                    "onUpdate:requirements": handleUpdateRequirements,
                    onOpenPolicyTab: goToAttendancePolicyTab
                  }, null, 8, ["schedule-id", "isSaving"]))
                : _createCommentVNode("", true),
              (tabs.value[tab.value - 1] === TAB_EXCHANGE_CONFIG)
                ? (_openBlock(), _createBlock(ExchangeConfigTab, {
                    key: 2,
                    ref_key: "exchangeConfigTabRef",
                    ref: exchangeConfigTabRef,
                    "schedule-id": props.scheduleDetails.id,
                    isSaving: isSaving.value,
                    "onUpdate:isSaving": _cache[2] || (_cache[2] = ($event: any) => ((isSaving).value = $event))
                  }, null, 8, ["schedule-id", "isSaving"]))
                : _createCommentVNode("", true),
              (tabs.value[tab.value - 1] === TAB_EXCEPTIONALITY)
                ? (_openBlock(), _createBlock(ScheduleApprovalFlowTab, {
                    key: 3,
                    ref_key: "approvalFlowTabRef",
                    ref: approvalFlowTabRef,
                    "schedule-id": props.scheduleDetails.id,
                    "company-id": props.scheduleDetails.companyId,
                    isSaving: isSaving.value,
                    "onUpdate:isSaving": _cache[3] || (_cache[3] = ($event: any) => ((isSaving).value = $event))
                  }, null, 8, ["schedule-id", "company-id", "isSaving"]))
                : _createCommentVNode("", true),
              (tabs.value[tab.value - 1] === TAB_ATTENDANCE_POLICY)
                ? (_openBlock(), _createBlock(ScheduleDsAttendancePolicyTab, {
                    key: 4,
                    ref_key: "schaleRegistroTabRef",
                    ref: schaleRegistroTabRef,
                    "schedule-id": props.scheduleDetails.id,
                    "schedule-end-date": props.scheduleDetails.endDate,
                    "is-saving": isSaving.value,
                    hasUnsavedChanges: hasUnsavedChanges.value,
                    "onUpdate:hasUnsavedChanges": _cache[4] || (_cache[4] = ($event: any) => ((hasUnsavedChanges).value = $event))
                  }, null, 8, ["schedule-id", "schedule-end-date", "is-saving", "hasUnsavedChanges"]))
                : _createCommentVNode("", true),
              (tabs.value[tab.value - 1] === TAB_RESTRICTION_POLICY)
                ? (_openBlock(), _createBlock(PolicyLinksTab, {
                    key: 5,
                    ref_key: "policyLinksTabRef",
                    ref: policyLinksTabRef,
                    "schedule-id": props.scheduleDetails.id,
                    "schedule-end-date": props.scheduleDetails.endDate,
                    isSaving: isSaving.value,
                    "onUpdate:isSaving": _cache[5] || (_cache[5] = ($event: any) => ((isSaving).value = $event)),
                    hasUnsavedChanges: hasUnsavedChanges.value,
                    "onUpdate:hasUnsavedChanges": _cache[6] || (_cache[6] = ($event: any) => ((hasUnsavedChanges).value = $event))
                  }, null, 8, ["schedule-id", "schedule-end-date", "isSaving", "hasUnsavedChanges"]))
                : _createCommentVNode("", true),
              (tabs.value[tab.value - 1] === TAB_QUALIFICATION)
                ? (_openBlock(), _createBlock(QualificationTab, {
                    key: 6,
                    "schedule-id": props.scheduleDetails.id
                  }, null, 8, ["schedule-id"]))
                : _createCommentVNode("", true),
              (tabs.value[tab.value - 1] === TAB_QUALIFICATION_DOC)
                ? (_openBlock(), _createBlock(QualificationDocTab, {
                    key: 7,
                    "schedule-id": props.scheduleDetails.id
                  }, null, 8, ["schedule-id"]))
                : _createCommentVNode("", true),
              (tabs.value[tab.value - 1] === TAB_PAYMENT_POLICY)
                ? (_openBlock(), _createBlock(PolicyPaymentTab, {
                    key: 8,
                    ref_key: "policyPaymentTabRef",
                    ref: policyPaymentTabRef,
                    "schedule-id": props.scheduleDetails.id,
                    onCreatePolicy: handleCreatePolicy,
                    onEditPolicy: handleEditPolicy,
                    onLoadedRequirements: handleRequirementsLoaded
                  }, null, 8, ["schedule-id"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(OutlinedButton, {
                  class: "flex-1",
                  text: "Fechar",
                  height: "48px",
                  onClick: handleToggleModal
                }),
                (hasSaveAction.value)
                  ? (_openBlock(), _createBlock(FilledButton, {
                      key: 0,
                      class: "flex-1",
                      disabled: saveDisabled.value,
                      loading: isSaving.value,
                      color: "primary30",
                      text: currentSaveLabel.value,
                      height: "48px",
                      onClick: handleSave
                    }, null, 8, ["disabled", "loading", "text"]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modalActive"]),
    (showUnsavedAlert.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "unsaved-overlay",
          onClick: _withModifiers(cancelLeave, ["self"])
        }, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("p", _hoisted_15, "Sair da aba " + _toDisplayString(currentTabName.value) + "?", 1),
              _createElementVNode("button", {
                class: "unsaved-close",
                onClick: cancelLeave
              }, _hoisted_17)
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("p", _hoisted_19, " Você tem edições não salvas na aba " + _toDisplayString(currentTabName.value?.toLowerCase()) + ". Se sair sem salvar, as alterações serão perdidas ", 1),
              _createElementVNode("div", { class: "unsaved-actions" }, [
                _createElementVNode("button", {
                  class: "unsaved-btn-voltar",
                  onClick: cancelLeave
                }, "Voltar"),
                _createElementVNode("button", {
                  class: "unsaved-btn-sair",
                  onClick: confirmLeave
                }, "Sair")
              ])
            ])
          ])
        ], 8, _hoisted_12))
      : _createCommentVNode("", true),
    _createVNode(PolicyPaymentModal, {
      visible: isCreatingPolicy.value || isEditingPolicy.value,
      edit: isEditingPolicy.value,
      policy: editedPaymentPolicy.value,
      scheduleId: props.scheduleDetails.id,
      scheduleName: props.scheduleDetails.name,
      "formation-required": requiresDoctorPaymentFormationRef.value,
      "schedule-details": props.scheduleDetails,
      "schedule-end-date": props.scheduleDetails.endDate,
      onClose: closePolicyModal,
      onCreated: handlePolicyChange,
      onUpdated: handlePolicyChange
    }, null, 8, ["visible", "edit", "policy", "scheduleId", "scheduleName", "formation-required", "schedule-details", "schedule-end-date"])
  ], 64))
}
}

})